// extracted by mini-css-extract-plugin
export default {"buttons":"ProjectTags_buttons__Cm0iE","newTag":"ProjectTags_newTag__-kvOi","search":"ProjectTags_search__k91jx"};